// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XNbj","left":"styles_left__2Ajfa","right":"styles_right__10rrn","alert":"styles_alert__2AJtF"};